const footerColumns = [
  {
    title: "入口相关",
    links: [
      { label: "入口类型说明", id: "entries" },
      { label: "发布页说明", id: "publish" },
      { label: "入口维护说明", id: "notes" },
    ],
  },
  {
    title: "内容与使用",
    links: [
      { label: "栏目概览", id: "categories" },
      { label: "访问与防走失指南", id: "guide" },
      { label: "常见问题", id: "faq" },
    ],
  },
  {
    title: "说明",
    links: [
      { label: "安全与免责声明", id: "disclaimer" },
      { label: "回到页面顶部", id: "top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                大师兄影视
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-900 max-w-sm">
              本站为围绕大师兄影视的平台入口说明页，集中整理最新地址、官网入口、官方网址、发布页与永久入口等常见查询内容，
              帮助访客在同一页面内完成查找与核对。
            </p>
            <div className="mt-5 flex items-center gap-2 flex-wrap">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-label rounded-full bg-background-50 text-secondary-900 border border-secondary-200">
                <i className="ri-information-line" />
                信息整合展示
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-label rounded-full bg-background-50 text-secondary-900 border border-secondary-200">
                <i className="ri-bookmark-line" />
                建议收藏本页
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-label font-semibold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-secondary-900 hover:text-primary-700 transition-colors cursor-pointer text-left"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-secondary-900">
            本站内容仅作信息整理与说明之用，不提供任何在线播放与下载服务。
          </p>
          <p className="text-xs text-secondary-900">
            请以发布页同步的信息为准 · 理性浏览，安全上网
          </p>
        </div>
      </div>
    </footer>
  );
}